@if (isLoading) {
    <div class="text-center">
        <div class="spinner-border text-primary"></div>
    </div>
} @else {
    <ul class="list-group-flush m-0 p-0">
        <ng-template
            *ngFor="let history of history; let index = index"
            [ngTemplateOutlet]="row"
            [ngTemplateOutletContext]="{
                title: history.title,
                subtitle: history.subtitle,
                badges: history.badges,
                date: history.date,
                performedBy: history.performedBy,
                userName: history.userName,
                userEmailAddress: history.userEmailAddress,
                isGrouped: isGroupedRow(index),
                hasPreviousGroupLink: hasPreviousGroupLink(index),
                hasNextGroupLink: hasNextGroupLink(index),
            }"
        >
        </ng-template>
    </ul>
}

<ng-template
    #row
    let-title="title"
    let-subtitle="subtitle"
    let-badges="badges"
    let-date="date"
    let-performedBy="performedBy"
    let-userName="userName"
    let-userEmailAddress="userEmailAddress"
    let-isGrouped="isGrouped"
    let-hasPreviousGroupLink="hasPreviousGroupLink"
    let-hasNextGroupLink="hasNextGroupLink"
>
    <li
        class="booking-history-row p-2 border-bottom list-group-item rounded-0"
        [class.booking-history-row--grouped]="isGrouped"
        [class.booking-history-row--group-start]="isGrouped && !hasPreviousGroupLink"
        [class.booking-history-row--group-middle]="hasPreviousGroupLink && hasNextGroupLink"
        [class.booking-history-row--group-end]="isGrouped && !hasNextGroupLink"
    >
        <div class="py-1 hstack gap-2 justify-content-between">
            <div class="vstack">
                <span class="text-dark-subtle">
                    {{ title }}
                </span>
                @if (subtitle) {
                    <span class="fw-semibold">
                        {{ subtitle }}
                    </span>
                }
                @if (badges && badges.length > 0) {
                    <div class="d-flex flex-wrap gap-1 mt-1">
                        @for (badge of badges; track badge.value) {
                            <span class="badge text-bg-light">
                                <small>{{ badge.label }}:</small> {{ badge.value }}
                            </span>
                        }
                    </div>
                }
            </div>
            <ng-template
                [ngTemplateOutlet]="dateAndTime"
                [ngTemplateOutletContext]="{
                    date: date,
                    performedBy: performedBy,
                    userName: userName,
                    userEmailAddress: userEmailAddress,
                }"
            ></ng-template>
            </div>
    </li>
</ng-template>

<ng-template
    #dateAndTime
    let-date="date"
    let-performedBy="performedBy"
    let-userName="userName"
    let-userEmailAddress="userEmailAddress"
>
    <div class="vstack gap-1 align-items-end">
        @if (performedBy) {
            @if (performedBy === 'customer') {
                <app-booking-source-badge
                    [source]="BookingSource.Customer"
                    size="small"
                >
                </app-booking-source-badge>
            } @else if (userName || userEmailAddress) {
                <app-booking-source-badge
                    [source]="BookingSource.Merchant"
                    size="small"
                    [hasCustomLabel]="true"
                >
                    <span customLabel>{{ userName ? userName + (userEmailAddress ? ' · ' + userEmailAddress : '') : userEmailAddress }}</span>
                </app-booking-source-badge>
            } @else {
                <app-booking-source-badge
                    [source]="BookingSource.Merchant"
                    size="small"
                >
                </app-booking-source-badge>
            }
        }
        <div class="hstack gap-2 justify-content-end">
            <span class="fw-semibold">
                {{ date | date: 'shortDate' }}
            </span>
            <span class="text-dark-subtle">
                at
            </span>
            <span class="fw-semibold">
                {{ date | date: 'shortTime' }}
            </span>
        </div>
    </div>
</ng-template>
